// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pG8d","label":"styles_label__h_ijg"};